import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
    initTaxiOrder,
    notifyInitialWhatsApp,
    triggerTaxiRouting,
    getTaxiRoutingJob
} from "../../api/taxi/taxiApi"; // Ajusta tu ruta de importación

import {
    subscribeTaxiRoutingJob
} from "../../api/taxi/taxiRoutingStream";

export const useTaxiWorkflow = (showAlert, refetchTravelers, onSuccessCreation) => {
    const queryClient = useQueryClient();

    // Mutación de la Etapa 1: Inicializar la OS de Taxi desde el Manifiesto del Bus
    const initTaxiMutation = useMutation({
        mutationFn: ({ parentOrderId, manId }) => initTaxiOrder(parentOrderId, manId),
        onSuccess: (data) => {
            showAlert("Servicio de transbordo a taxi inicializado correctamente.");
            queryClient.invalidateQueries(["service-order"]);
            //queryClient.invalidateQueries(["viajeros"]);
            queryClient.invalidateQueries({ queryKey: ["viajeros"]});
            if (refetchTravelers) refetchTravelers();
            // Callback para pasar el nuevo ID al componente visual
            if (onSuccessCreation && data) onSuccessCreation(data);
        },
        onError: (error) => {
            showAlert(error?.response?.data?.error || "Error al inicializar el servicio de taxi.", "error");
        }
    });

    // Mutación de la Etapa 2: Envío masivo inicial de notificaciones de procesamiento
    const notifyInitialMutation = useMutation({
        mutationFn: (taxiOSId) => notifyInitialWhatsApp(taxiOSId),
        onSuccess: () => {
            showAlert("Notificaciones masivas de WhatsApp enviadas con éxito a los pasajeros.");
        },
        onError: (error) => {
            showAlert(error?.response?.data?.error || "Error al despachar las notificaciones.", "error");
        }
    });

    // Mutación de la Etapa 3: Optimización VRP y segmentación en sub-manifiestos
    const generateRoutesMutation = useMutation({
        mutationFn: taxiOSId =>
            triggerTaxiRouting(taxiOSId),

        onError: error => {
            showAlert(
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                "No fue posible iniciar el ruteo.",
                "error"
            );
        }
    });

    const refreshAfterRouting = async () => {
        await Promise.all([
            queryClient.invalidateQueries({
                queryKey: ["service-order"]
            }),

            queryClient.invalidateQueries({
                queryKey: ["viajeros"]
            })
        ]);

        await refetchTravelers?.();
    };

    return {
        initTaxiMutation,
        notifyInitialMutation,
        generateRoutesMutation,

        subscribeTaxiRoutingJob,
        getTaxiRoutingJob,
        refreshAfterRouting,

        isWorkflowBusy:
            initTaxiMutation.isPending ||
            notifyInitialMutation.isPending ||
            generateRoutesMutation.isPending ||
            initTaxiMutation.isLoading ||
            notifyInitialMutation.isLoading ||
            generateRoutesMutation.isLoading
    };
};